export const ActionInputFieldLabels = {
  title: 'Title',
  description: 'Description',
  attachment: 'Attachments',
  assignTask: 'Assign Task',
  assignControls: 'Assign Controls',
  taskFiles: 'Document References'
} as const;

export type HazardActionInputField = keyof typeof ActionInputFieldLabels;

export const ActionInputFields: HazardActionInputField[] = Object.keys(
  ActionInputFieldLabels
) as HazardActionInputField[];
